import factory from "../utils/block-factory";
import Faq from "./faq";
import Pricing from "./pricing";
import Calculator from "./calculator";
import SuccessStories from "./success-stories";
import Cta from "./cta";

factory("faq", Faq);
factory("pricing", Pricing);
factory("calculator", Calculator);
factory("success-stories", SuccessStories);
factory("form-cta", Cta);
